import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../01_atoms/Button';

import styles from './index.module.scss';

const RelatedCategories = ({ relatedCategories }) => {
  const [isVisible, setVisible] = useState(false);

  return (
    <div className={styles['resource-categories-list']}>
      {relatedCategories.map((item, index) => (
        <Button
          tag="a"
          type="secondary"
          isOutlined={true}
          size="small"
          key={item.url}
          href={item.url}
          className={`analytics-resource-page-related-link ${
            !isVisible && index > 3 ? styles['mobile-hide'] : ''
          }`}
        >
          {item.label}
        </Button>
      ))}
      {relatedCategories.length > 4 && (
        <Button
          type="secondary"
          isOutlined={true}
          size="small"
          onClick={() => setVisible(!isVisible)}
          onKeyPress={() => setVisible(!isVisible)}
          className={styles['more-button']}
        >
          {isVisible ? `hide ${relatedCategories.length - 4}` : `+ ${relatedCategories.length - 4}`}
        </Button>
      )}
    </div>
  );
};

RelatedCategories.propTypes = {
  relatedCategories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
    }),
  ).isRequired,
};

export default RelatedCategories;
